/**
 * Searches for a param from a list of possible names.
 *
 * @param {Array} urlKeys - names of the URL parameters
 * @param {Object} urlParams - all search parameters in the current URL
 * @returns {String|Null} - Value of the parameter found or null.
 */
function getParamFromUrl(urlKeys, urlParams) {
  let i, urlParam;
  for (i = 0; i < urlKeys.length; i += 1) {
    urlParam = urlParams[urlKeys[i]];
    if (urlParam != null) {
      return urlParam;
    }
  }

  return null;
}

export default getParamFromUrl;
